"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { assertUnreachable, isEthereumAddress } from "@/helpers/AllowlistToolHelpers";
import DistributionPlanToolNotConnected from "./distribution-plan-tool-not-connected";
import DistributionPlanToolConnected from "./distribution-plan-tool-connected";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
enum DistributionPlanAuth {
  NOT_CONNECTED = "NOT_CONNECTED",
  CONNECTED = "CONNECTED",
}
export default function DistributionPlanToolConnect() {
  const $ = _c(7);
  const {
    address
  } = useSeizeConnectContext();
  const [authStatus, setAuthStatus] = useState(DistributionPlanAuth.NOT_CONNECTED);
  let t0;
  let t1;
  if ($[0] !== address) {
    t0 = () => {
      if (address && isEthereumAddress(address)) {
        setAuthStatus(DistributionPlanAuth.CONNECTED);
        return;
      }
      setAuthStatus(DistributionPlanAuth.NOT_CONNECTED);
    };
    t1 = [address];
    $[0] = address;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  bb0: switch (authStatus) {
    case DistributionPlanAuth.NOT_CONNECTED:
      {
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <DistributionPlanToolNotConnected />;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        t2 = t3;
        break bb0;
      }
    case DistributionPlanAuth.CONNECTED:
      {
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <DistributionPlanToolConnected />;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        t2 = t3;
        break bb0;
      }
    default:
      {
        assertUnreachable(authStatus);
        t2 = null;
      }
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="xl:tw-max-w-2xl xl:tw-mx-auto lg:tw-px-8 xl:tw-px-0"><div>{t2}</div></div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}